module.exports = __webpack_public_path__ + "static/promo-1016c76806b1a88705493ae7f627248b.png";